import { Box, Flex, Image } from '@modusign/design-system';
import { useGetUserInfo } from '@modusign/openapi-client-user';

import SurveyUserCompany from '@app/assets/survey-user-company.svg';
import SurveyUserIndividual from '@app/assets/survey-user-individual.svg';
import { Survey } from '@app/containers/Modal/WelcomeSurveyModal';

interface UserTypeStepProps {
  nextStep: () => void;
  setSurvey: (update: (survey: Survey) => Survey) => void;
}

function UserTypeStep({ nextStep, setSurvey }: UserTypeStepProps) {
  const { data: user } = useGetUserInfo();
  return (
    <>
      <Box fontSize={2} fontWeight="medium" mt={2}>
        가입자 유형을 선택해 주세요.
      </Box>
      <Flex mt={8}>
        {[
          { src: SurveyUserIndividual, title: '개인 이용자', value: '개인 이용자' },
          {
            src: SurveyUserCompany,
            title: '회사 · 단체 · 개인 사업자',
            value: '회사·단체·개인 사업자',
          },
        ].map(({ src, title, value }) => (
          <Flex
            alignItems="center"
            borderColor="boxBorderNeutralBase"
            borderRadius="3px"
            borderStyle="solid"
            borderWidth="1px"
            color="textNeutralSlightlyLight"
            flex={1}
            flexBasis={['100%', 0]}
            flexDirection="column"
            fontSize={[0, 1]}
            height="191px"
            key={title}
            px={5}
            py={8}
            sx={{
              '&:hover': {
                cursor: 'pointer',
                borderColor: 'boxBorderEmphasisBase',
                color: 'textEmphasisBase',
              },
              '&:not(:first-child)': {
                ml: 4,
              },
            }}
            textAlign="center"
            onClick={() => {
              if (value === '개인 이용자') {
                setSurvey((survey) => ({
                  ...survey,
                  userType: value,
                  companyName: user?.profile.name || '',
                  jobRole: ['기타'],
                  companyScale: '개인(1인기업)',
                  companyCategory: '소속 없음',
                  department: '소속 없음',
                }));
              } else {
                setSurvey((survey) => ({ ...survey, userType: value }));
              }
              nextStep();
            }}
          >
            <Flex height="80px">
              <Image alt={title} draggable="false" src={src} />
            </Flex>
            <Box fontWeight="medium" mt={8} sx={{ wordBreak: 'keep-all' }}>
              {title}
            </Box>
          </Flex>
        ))}
      </Flex>
    </>
  );
}

export default UserTypeStep;
